export default {
  data() {
    return {
      // isSearching: false,
      search: '',
      searchError: '',
    }
  },
  computed: {
    isSearching: {
      // getter
      get() {
        return this.$store.getters['app/is_searching']
      },
      // setter
      set(newValue) {
        this.blockStateChange(() => this.$store.commit('app/SET_SEARCHING', newValue))
      },
    },
  },
  props: {
    querySearch: {
      type: String,
      default: '',
      required: false,
    },
  },
  methods: {
    // On change input search
    searchAction(search) {
      if (search !== this.$route.query.search) {
        if (this.$route.query.search != null && search.length != 0 && this.min_search_length && search.length < this.min_search_length) {
          if (this.min_search_length) this.searchError = 'Search for min ' + this.min_search_length + ' characters'
        } else if (
          !(this.$route.query.search == null && (search.length == 0 || (this.min_search_length && search.length < this.min_search_length)))
        ) {
          this.searchError = ''
          // SET SEARCHING ACTION
          this.isSearching = true

          const query = { ...this.$route.query }

          // Delete page
          delete query.page

          // Assign new search to route
          Object.assign(query, { search: search })

          // Delete empty searches
          if (query.search === '') {
            delete query.search
          }
          this.$router.push({ query: query })
        } else {
          if (this.min_search_length) this.searchError = 'Search for min ' + this.min_search_length + ' characters'
        }
      }
    },
  },
  mounted() {
    this.search = this.querySearch || this.$route.query.search
  },
  watch: {
    querySearch() {
      this.search = this.querySearch
      if (this.search !== this.$route.query.search) {
        // SET SEARCHING ACTION
        this.isSearching = true
      }
    },
  },
}
